export enum HostEnv {
  Prod = 'PROD',
  Stage = 'STAGE',
  Uat = 'UAT'
}

export const hostEnv = {
  [HostEnv.Uat]: 'https://brand-sdk.kmsmep.com/',
  [HostEnv.Stage]: 'https://brand-sdk.kmsmep.com/',
  [HostEnv.Prod]: 'https://brand-sdk.kmsmep.com/'
};

export const fmcApiBaseUrlEnv = {
  [HostEnv.Uat]: 'https://acquire1uat.comenity.net',
  [HostEnv.Stage]: 'https://acquire1stage.comenity.net',
  [HostEnv.Prod]: 'https://acquire1.comenity.net'
};

export const apiHostEnv = {
  [HostEnv.Uat]: 'https://brands-staging.kmsmep.com',
  [HostEnv.Stage]: 'https://brands-staging.kmsmep.com',
  [HostEnv.Prod]: 'https://brands.kmsmep.com'
};
